/* eslint-disable no-console */
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

export const StandardConfigEditor = ({
  availableFields: _unused,
  value: _unused2,
  onChange: _unused3,
}: {
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeFilterStandardCalculationConfig;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeFilterStandardCalculationConfig,
  ) => void;
}) => {
  // there is nothing to render for standard config
  return <></>;
};
